// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Button, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { IQuoteDetail } from '~/utils/interface/quotes';
import { DateFormatEnum } from '~/utils/enum/common';
import { formatCurrencyUSD, formatDate } from '~/utils/helper/common';
import { IOrderDetail } from '~/utils/interface/order';
// Styles, images, icons
import styles from './FeesOrderDetail.module.scss';
import { icons } from '~/assets';

type Props = {
  detailOrder?: IOrderDetail;
};

const cx = classNames.bind(styles);

const FeesOrderDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailOrder } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack gap={1} className={cx('container')}>
      <Typography className={cx('title')}>{t('quote_detail_title_fee_summary')}</Typography>

      <Grid2 container spacing={2}>
        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_labor_cost', {
              laborCost: formatCurrencyUSD({ value: detailOrder?.laborCost, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_labor_fee', {
              laborFee: formatCurrencyUSD({ value: detailOrder?.laborFee, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_delivery', {
              deliveryCost: formatCurrencyUSD({ value: detailOrder?.deliveryCost, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_damage_waiver', {
              damageWaiver: formatCurrencyUSD({ value: detailOrder?.damageWaiver, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_discount', {
              discount: formatCurrencyUSD({ value: detailOrder?.discountRate, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_deposit_due', {
              depositDueDate: formatDate(detailOrder?.depositDueDate, DateFormatEnum.MM_DD_YYYY),
            })}
          </Typography>
        </Grid2>

        {detailOrder?.orderCustom &&
          detailOrder?.orderCustom.length > 0 &&
          detailOrder?.orderCustom.map((item, index) => (
            <Grid2 size={4} key={index}>
              <Typography key={index} className={cx('subTitle')}>
                {t('form_quotes_title_fee', {
                  feeName: item?.customFeeName,
                  feeAmount: formatCurrencyUSD({ value: item?.customFeeAmount, showDecimal: true }),
                })}
              </Typography>
            </Grid2>
          ))}
      </Grid2>
    </Stack>
  );
};

export default FeesOrderDetail;
